module.exports = __webpack_public_path__ + "img/BSA logo new.dd6d1edc.png";